import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Modal, Box, Button, TextField, Grid } from '@mui/material';

const WorkoutModal = ({ isOpen, workout, onClose, onSave }) => {
  const [cardioValues, setCardioValues] = useState({
    calories: 0,
    time_minutes: 0,
    distance_km: 0,
  });
  const [strengthValues, setStrengthValues] = useState({
    time_minutes: 0,
    sets: 0,
    repetitions: 0,
  });
  const [workoutOrder, setWorkoutOrder] = useState('');

  useEffect(() => {
    if (workout) {
      setCardioValues(workout.cardioValues);
      setStrengthValues(workout.strengthValues);
      setWorkoutOrder(workout.workout_order || '');
    }
  }, [workout]);

  const handleCardioChange = (e) => {
    const { name, value } = e.target;
    setCardioValues((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleStrengthChange = (e) => {
    const { name, value } = e.target;
    setStrengthValues((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSave = (e) => {
    e.preventDefault();

    // Validate if the values are numbers and set empty values to 0
    const normalizedCardioValues = {
      calories: isNaN(cardioValues.calories) || cardioValues.calories === '' ? 0 : parseFloat(cardioValues.calories),
      time_minutes: isNaN(cardioValues.time_minutes) || cardioValues.time_minutes === '' ? 0 : parseFloat(cardioValues.time_minutes),
      distance_km: isNaN(cardioValues.distance_km) || cardioValues.distance_km === '' ? 0 : parseFloat(cardioValues.distance_km),
    };

    const normalizedStrengthValues = {
      time_minutes: isNaN(strengthValues.time_minutes) || strengthValues.time_minutes === '' ? 0 : parseFloat(strengthValues.time_minutes),
      sets: isNaN(strengthValues.sets) || strengthValues.sets === '' ? 0 : parseFloat(strengthValues.sets),
      repetitions: isNaN(strengthValues.repetitions) || strengthValues.repetitions === '' ? 0 : parseFloat(strengthValues.repetitions),
    };

    // Check if all values are numbers and do not allow save if not
    if (
      isNaN(normalizedCardioValues.calories) ||
      isNaN(normalizedCardioValues.time_minutes) ||
      isNaN(normalizedCardioValues.distance_km) ||
      isNaN(normalizedStrengthValues.time_minutes) ||
      isNaN(normalizedStrengthValues.sets) ||
      isNaN(normalizedStrengthValues.repetitions)
    ) {
      alert('Unesite ispravnu vrijednost za polja');
      return;
    }

    onSave({
      ...workout,
      cardioValues: normalizedCardioValues,
      strengthValues: normalizedStrengthValues,
      workout_order: workoutOrder,
    });
  };

  return (
    <Modal open={isOpen} onClose={onClose}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '80%',
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 4,
        }}
      >
        <h2>{workout ? 'Uredi vježbu' : 'Dodaj vježbu'}</h2>
        <form onSubmit={handleSave}>
          <TextField
            label="Naziv vježbe"
            variant="outlined"
            fullWidth
            defaultValue={workout ? workout.name : ''}
            disabled
            margin="normal"
          />
          <TextField
            label="Opis"
            variant="outlined"
            fullWidth
            multiline
            rows={4}
            defaultValue={workout ? workout.description : ''}
            disabled
            margin="normal"
          />

          <h3>Cardio</h3>
          <Grid container spacing={2}>
            <Grid item xs={4}>
              <TextField
                label="Kalorije"
                variant="outlined"
                type="number"
                fullWidth
                name="calories"
                value={cardioValues.calories}
                onChange={handleCardioChange}
                margin="normal"
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                label="Vrijeme (minute)"
                variant="outlined"
                type="number"
                fullWidth
                name="time_minutes"
                value={cardioValues.time_minutes}
                onChange={handleCardioChange}
                margin="normal"
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                label="Udaljenost (km)"
                variant="outlined"
                type="number"
                fullWidth
                name="distance_km"
                value={cardioValues.distance_km}
                onChange={handleCardioChange}
                margin="normal"
              />
            </Grid>
          </Grid>

          <h3>Strength</h3>
          <Grid container spacing={2}>
            <Grid item xs={4}>
              <TextField
                label="Vrijeme (minute)"
                variant="outlined"
                type="number"
                fullWidth
                name="time_minutes"
                value={strengthValues.time_minutes}
                onChange={handleStrengthChange}
                margin="normal"
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                label="Setovi"
                variant="outlined"
                type="number"
                fullWidth
                name="sets"
                value={strengthValues.sets}
                onChange={handleStrengthChange}
                margin="normal"
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                label="Ponavljanja"
                variant="outlined"
                type="number"
                fullWidth
                name="repetitions"
                value={strengthValues.repetitions}
                onChange={handleStrengthChange}
                margin="normal"
              />
            </Grid>
          </Grid>

          <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '20px' }}>
            <Button variant="contained" type="submit" color="primary">
              Save
            </Button>
            <Button variant="outlined" onClick={onClose} color="secondary">
              Cancel
            </Button>
          </div>
        </form>
      </Box>
    </Modal>
  );
};

WorkoutModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  workout: PropTypes.object,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
};

export default WorkoutModal;
